/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Container from 'components/Container';
import UnauthenticatedView from './UnauthenticatedView';

export class AuthenticationView extends React.Component<{
  children: React.Node,
  className?: string,
  size: 'large' | 'medium' | 'small' | 'xsmall',
}> {
  static defaultProps = {
    size: 'xsmall',
  };

  render() {
    const { className, size, ...props } = this.props;

    return (
      <UnauthenticatedView {...props} className={cx('AuthenticationView', className)}>
        <Container size={size}>
          <Box>
            <BoxBody>{this.props.children}</BoxBody>
          </Box>
        </Container>
      </UnauthenticatedView>
    );
  }
}

export default AuthenticationView;
